// client/src/routes/app/buildings/$buildingId.tsx — SCR-BLD-002 „Clădire" · D-3361 (04 §8.21).
//
// ONE ROUTE, and the six tabs are `?tab=` rather than child routes — the shape „Chiriaș la rândul
// meu" took (D-1190). The route owns the URL state and nothing else: `validateSearch` runs the
// schema and the profile reads it back typed, so a tab is shareable and Back undoes it. Lane 1 owns
// the bar; the lanes that build „Locatari", „Contoare", „Citiri" and „Tichete" fill components of
// their own that the profile already mounts.

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { RequirePermission } from '@/components/layout/route-guards';
import { BuildingProfile } from '@/features/buildings/manage/BuildingProfile';
import { buildingSearchSchema, type BuildingSearch } from '@/features/buildings/search';

export const Route = createFileRoute('/app/buildings/$buildingId')({
  validateSearch: buildingSearchSchema,
  component: BuildingScreen,
});

function BuildingScreen() {
  const { buildingId } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });

  return (
    <RequirePermission permission="Buildings.Manage">
      <BuildingProfile
        buildingId={buildingId}
        search={search}
        onSearchChange={(next: (previous: BuildingSearch) => BuildingSearch) => {
          void navigate({ search: next });
        }}
      />
    </RequirePermission>
  );
}
